import { DefaultRoutes } from './routes.constants';

/** Base del árbol de rutas del dashboard de comité (lazy + hijas futuras). */
const COMMITTEE_ROUTE_PREFIX = DefaultRoutes.COMMITTEE_DASHBOARD;

export function isCommitteeAllowedUrl(url: string): boolean {
  const normalized = url.split('?')[0];
  return normalized === COMMITTEE_ROUTE_PREFIX || normalized.startsWith(`${COMMITTEE_ROUTE_PREFIX}/`);
}
